import { useQuery } from '@tanstack/react-query'
import type { GetProductsAPIResponse, Item } from 'typings'
import { useFetch } from './useFetch'
import { SEARCH_TERM_PAGE_SIZE, sortTermById } from './utils'

type Response = {
  items: Item[]
  total: number
}

type Options = {
  searchTerm?: string
  enabled?: boolean
}

export function useProducts(options: Options) {
  const { searchTerm, enabled = true } = options

  const { fetcherWrapper } = useFetch()

  const page = 1
  const itemsPerPage = searchTerm ? SEARCH_TERM_PAGE_SIZE : 10

  const url = new URL(
    `/api/proxy/catalog_system/pvt/products/GetProducts`,
    window.location.origin
  )

  url.search = new URLSearchParams({
    filter: searchTerm ?? '',
    page: String(page),
    pagesize: String(itemsPerPage),
  }).toString()

  async function fetcher() {
    return fetcherWrapper(url.toString())
      .then((r) => r.json())
      .then((r: GetProductsAPIResponse) => ({
        items: r.items
          .map<Item>((item) => ({
            name: item.productName.trim(),
            id: String(item.productId),
          }))
          .sort((item) => sortTermById(item.id, searchTerm)),
        total: r.paging.total,
      }))
  }

  return useQuery<Response>({
    queryKey: ['products', searchTerm],
    queryFn: fetcher,
    enabled,
  })
}
